@if (isLoading) {
<div
  class="{{ loadingClass }} d-flex justify-content-center align-items-center"
>
  <mat-spinner [diameter]="60"></mat-spinner>
</div>
}
